<tfoot>
  <tr>
    <td colspan="100%" class="grey lighten-5 w-100">
      <div class="d-flex">
        <div>
          Página {{ context.CurrentPage }} de {{ context.PagesCount }}
          ({{ context.RecordsCount }} registros)
        </div>
        <div class="btn-toolbar" role="toolbar">
          <div class="btn-group">
            <div *ngIf="showPrev">
              <button mdbBtn type="button" color="primary" mdbWavesEffect size="sm" (click)="goBack()">
                <mdb-icon fas icon="angle-left" class="mr-1"></mdb-icon>Anterior
              </button>
            </div>
            &nbsp;
            <div *ngIf="showNext">
              <button mdbBtn type="button" color="primary" mdbWavesEffect size="sm" (click)="goNext()">
                Siguiente
                <mdb-icon fas icon="angle-right" class="ml-1"></mdb-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</tfoot>
